import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function currentDateReducer(state = initialState.currentDate, action) {
    switch (action.type) {
        case types.SET_CURRENT_DATE:
            return action.date;

        default:
            return state;
    }
}




/** WEBPACK FOOTER **
 ** ./src/reducers/currentDateReducer.js
 **/